import { withTheme } from "@emotion/react";
import CITFormGroup from "../../../../Form/CITFormGroup"
import { Typography, Box, Stack } from "@mui/material";
import * as React from 'react';
import FileInput from "../../../../Form/FileInput";
import DateInput from "../../../../Form/DateInput";



const EmployabilityStatement = (props) => {

    const theme = props.theme

    return (

        <Box width={'inherit'}>
            <Stack mx={{ xs: '19px', sm: '60px', md: '85px' }} justifyContent={'space-around'} mt={'24px'} >
                <Typography width={{ sm: '668px', md: '998px' }} mb={'24px'} mt={'48px'} sx={{ ...theme.typography.heading, fontSize: { xs: '18px', sm: '20px', md: '29px' } }} gutterBottom>
                    {'STATEMENT OF EMPLOYABILITY'}
                </Typography>
                <Typography mb={'24px'} sx={theme.typography.body} gutterBottom>
                        By execution of this document, I acknowledge that I have been informed by Care In Touch Home Health Agency 
                        and agree that Care In Touch Home Health Agency may conduct a State of California criminal history check. I agree
                        to a search of the Employee Misconduct Registry prior to employment and at least every twelve (12) months if hired.
                        I understand that these checks will determine if I have a criminal conviction or have committed certain conduct that 
                        will bar me from employment with Care In Touch Home Health Agency. Criminal History Check I have informed
                        Care In Touch Home Health Agency of all names (i.e. maiden, aliases) that I have used in the past. I understand that
                        my mployment is pending the results of the criminal history check, and that I may not have face-to-face patient 
                        contact until results are returned. I will be notified of results.
                </Typography>
                <Typography mb={'24px'} sx={{...theme.typography.body, fontWeight:700} } gutterBottom>
                        Convictions Barring Employment.
                </Typography>
                <Typography mb={'24px'} sx={theme.typography.body} gutterBottom>
                       <Box display={'inline'} ><Typography  sx={{...theme.typography.body, fontWeight:700,display:'inline'} } gutterBottom>A) </Typography></Box>A person for whom the facility is entitled to obtain criminal history record information may not be employed in a 
                        facility if the person has
                        been convicted of an offense listed in this subsection;
                        An offense under Chapter 19, Penal Code (criminal homicide); An offense under Chapter 20, Penal Code (kidnapping
                        and
                        unlawful retention); An offense under Section 21.02, Penal Code (continuous sexual abuse of a young child or
                        children); An
                        offense under Section 21.08, Penal Code (indecent exposure); An offense under Section 21.11, Penal
                        code (indecency with a
                        child); An offense under Section 21.12, Penal Code (improper relationship between educator
                        and student); An offense under
                        21.15, Penal Code (improper photography or visual recording); An offense under 
                        22.011, Penal Code (sexual assault); An offense
                        under Section 22.02, Penal Code (aggravated assault); An offense 
                        under Section 22.021, Penal Code (aggravated sexual assault);
                        An offense under Section 22.04, Penal Code (injury 
                        to a child, elderly individual, or a disabled individual); An offense under
                        Section 22.041, Penal Code (abandoning or 
                        endangering a child); An offense under Section 22.05, Penal Code (deadly conduct);
                        An offense under Section 22.07
                        Penal Code (terroristic threat); An offense under Section 22.08, Penal Code (aiding suicide); An
                        offense under 
                        Section 25.031, Penal Code (agreement to abduct from custody); An offense under Section 25.08, Penal Code (sale
                        or purchase of a child); An offense under Section 28.02, Penal Code (arson); An offense under Section 29.02, Penal
                        Code
                        (robbery); An offense under Section 29.03, Penal Code (aggravated robbery); An offense under Section 
                        33.021, Penal Code
                        (online solicitation of a minor); An offense under Section 34.02, Penal Code (money laundering);
                        An offense under Section
                        35A.02, Penal Code (Medicaid fraud); An offense under Section 42.09, Penal Code 
                        (cruelty to animals) or A conviction under the
                        laws of another state, federal law, or the Uniform Code of Military 
                        Justice for an offense containing elements that are
                        substantially similar to the elements of an offense listed by this
                        subsection; An offense the Agency determines to be
                        contraindicated to the employment with the consumers the 
                        Agency serves.
                </Typography>
                <Typography mb={'24px'} sx={theme.typography.body} gutterBottom>
                <Box display={'inline'} ><Typography  sx={{...theme.typography.body, fontWeight:700,display:'inline'} } gutterBottom>B) </Typography></Box>
                        A person may also be barred from employment the duties of which involve direct contact with a client in a facility
                        if convicted of any of
                        the following crimes within the past 5 years:
                        An offense under Section 22.01, Penal Code (assault punishable as a Class A misdemeanor or as a felony); An 
                        offense under
                        Section 30.02, Penal Code (burglary); An offense under Chapter 31, Penal Code (theft that is 
                        punishable as a felony); An offense
                        under Section 32.45, Penal Code (misapplication of fiduciary property or 
                        property of a financial institution), that is punishable as
                        a Class A misdemeanor or a felony; or An offense under 
                        Section 32.46, Penal Code (securing execution of a document by
                        deception punishable as a Class A misdemeanor
                        or a felony); An offense under 37.12, Penal Code (false identification as a peace
                        officer); or An offense under 
                        Section 42.01(a)(7), (8), or (9), Penal Code (disorderly conduct).
                </Typography>
                <Typography mb={'24px'} sx={theme.typography.body} gutterBottom>
                <Box display={'inline'} > <Typography  sx={{...theme.typography.body, fontWeight:700,display:'inline'} } gutterBottom>C) </Typography></Box>
                        In addition to the prohibitions on employment prescribed by Subsections (A) and (B), a person for whom a facility
                        licensed under Chapter
                        242 or 247 is entitled to obtain criminal history record information may not be employed in
                        a facility licensed under Chapter 242 or 2476 if
                        the person has been convicted;
                        Of an offense under Section 30.02, Penal Code (burglary); or Under the laws of another state, federal law, or the 
                        Uniform Code of
                        Military Justice for an offense containing elements that are substantially similar to the elements of
                        an offense under Section
                        30.02, Penal Code.
                </Typography>
                <Typography mb={'24px'} sx={theme.typography.body} gutterBottom>
                <Box display={'inline'} ><Typography  sx={{...theme.typography.body, fontWeight:700,display:'inline'} } gutterBottom>D) </Typography></Box>
                        In addition to the prohibitions on employment prescribed by Subsections (A), (B), and (C), a nurse aide listed as
                        unemployable per amendment to TAC 40, §94.10(1) §(c) (d) and is listed on the NAR or EMR stating a finding of 
                        abuse, neglect or misappropriation will not
                        be recertified therefore, in unemployable.
                </Typography>
                <Typography mb={'24px'} sx={theme.typography.body} gutterBottom>
                <Box display={'inline'} ><Typography  sx={{...theme.typography.body, fontWeight:700,display:'inline'} } gutterBottom>E) </Typography></Box>
                        For purposes of this section, a person who is deferred adjudication community supervision for an offense listed
                        in this section, successfully
                        completes the period of deferred adjudication community supervision, and receives a
                        dismissal and discharge in accordance with Section
                        5(c), Article 42.12, Code of Criminal procedure, is not 
                        considered convicted of the offense for which the person received deferred
                        adjudication community supervision
                </Typography>
                <Typography mb={'24px'} sx={theme.typography.body} gutterBottom>
                        I acknowledge that if I am found to have been convicted of any other offense(s), that these offenses may also bar 
                        my employment. I understand that
                        all information obtained by Care In Touch Home Health Agency regarding any 
                        criminal history will remain confidential. I certify that the
                        information on this form contains no willful 
                        misrepresentation and that the information given is true and complete to the best of my knowledge.
                </Typography>
                <CITFormGroup mt={'0px'} mx={'0px'} width={'100%'}>
                        <FileInput showImage title="Add File" fileLable={'Your signature'} />
                        <DateInput dateLable={'Date'} />
                </CITFormGroup>
            </Stack>
        </Box>



    )
}

export default withTheme(EmployabilityStatement);